import styled from "styled-components";
import { Container, Row } from "@viagogo/core/ui";

export const BodyWrapper = styled.div<{ $secondaryBgColor?: boolean; addPrimaryBgColor?: boolean }>`
  width: 100%;
  height: 100%;
  background-color: ${(props) => {
    const backgroundColor = props.addPrimaryBgColor
      ? props.theme.colors.backgroundPrimary
      : props.theme.colors.backgroundSecondary;
    return props.$secondaryBgColor ? props.theme.palette.surfaceSecondary : backgroundColor;
  }};
`;

export const PaddedContainer = styled(Container)`
  padding-top: ${(props) => props.theme.spacing(2.25)};
`;

export const FlushContainer = styled(Container)`
  padding-top: 0;
`;

export const VerticalMarginRow = styled(Row)`
  margin-top: ${(props) => props.theme.spacing(36)};
  margin-bottom: ${(props) => props.theme.spacing(18)};
`;

export const MarginDivLarge = styled.div`
  margin: ${(props) => props.theme.spacing(8)} 0;
`;
